export default __webpack_public_path__ + "static/media/tag.5b762c1c.svg";